/* eslint-disable no-console */
import posthog from 'posthog-js'

declare module 'posthog-js' {
  interface PostHog {
    isInitialized?: boolean
  }
}

export const initPostHog = (): void => {
  const posthogKey = process.env.NEXT_PUBLIC_POSTHOG_KEY
  const posthogHost = process.env.NEXT_PUBLIC_POSTHOG_HOST

  if (typeof window === 'undefined') return

  if (!posthog.isInitialized) {
    if (!posthogKey || !posthogHost) {
      console.log('PostHog: key or host not defined')
      return
    }

    posthog.init(posthogKey, {
      api_host: 'https://s.moises.ai',
      ui_host: 'https://us.posthog.com',
      person_profiles: 'identified_only',
      session_recording: {
        recordCrossOriginIframes: true
      },
      capture_pageview: false,
      autocapture: false,
      advanced_disable_feature_flags_on_first_load: true,
      ...(window.location.search.includes('__posthog_debug') && {
        disable_compression: true
      })
    })

    posthog.isInitialized = true
    console.log('PostHog initialized successfully')
  }
}
